import { FETCH_APPT_CONFIGS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface TagRecord {
    doctor_oid: string;
    tag_id: number;
    label: string;
    hex: string;
    bg_hex: string;
    archive: boolean;
}

type UserPreference =
    | Record<'tdy_queue_cols' | 'upco_queue_cols' | 'cm_queue_cols' | 'oth_queue_cols', string[]>
    | Record<string, never>;

export type QueueConfigData = {
    tags: TagRecord[];
    user_preferences: UserPreference;
    eligibile_for_payments: boolean;
};

export default async function fetchApptConfigs(
    businessId: string,
): Promise<{
    success: boolean;
    data?: QueueConfigData;
    error?: string;
}> {
    return fetchWithRefresh(FETCH_APPT_CONFIGS(businessId), {
        mode: 'cors',
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw Error('failed to fetch appt configs');
        }
    });
}
